import { useState } from 'react';

const services = [
  {
    icon: 'ri-home-gear-fill',
    title: 'Installazione Professionale',
    description:
      'Installiamo stufe a pellet di ogni marca e modello con la massima cura e precisione. Lavoriamo in conformità alle normative vigenti, con posa canna fumaria inclusa.',
    points: ['Sopralluogo gratuito', 'Installazione certificata', 'Collaudo e avviamento'],
  },
  {
    icon: 'ri-calendar-check-fill',
    title: 'Manutenzione Programmata',
    description:
      'La pulizia periodica e la manutenzione preventiva prolungano la vita della tua stufa e ne garantiscono il massimo rendimento stagionale.',
    points: ['Pulizia completa', 'Controllo componenti', 'Sostituzione filtri'],
  },
  {
    icon: 'ri-tools-fill',
    title: 'Riparazioni e Assistenza',
    description:
      'Interveniamo rapidamente su guasti e anomalie. Il nostro team è disponibile 24/7 per emergenze, assicurando tempi di intervento rapidi.',
    points: ['Intervento entro 24h', 'Diagnosi gratuita', 'Ricambi originali'],
  },
  {
    icon: 'ri-customer-service-2-fill',
    title: 'Consulenza Personalizzata',
    description:
      'Ti aiutiamo a scegliere la stufa a pellet perfetta per le tue esigenze, tenendo conto del metraggio, del design dell\'ambiente e del budget disponibile.',
    points: ['Analisi fabbisogno', 'Preventivo dettagliato', 'Senza impegno'],
  },
];

export default function Servizi() {
  const [hovered, setHovered] = useState<number | null>(null);

  return (
    <section id="servizi" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">

        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block border-2 border-orange-500 text-orange-500 text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4">
            I Nostri Servizi
          </span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4">
            Soluzioni complete per ogni esigenza
          </h2>
          <p className="text-gray-500 text-base md:text-lg max-w-2xl mx-auto">
            Dalla scelta del modello alla manutenzione periodica, ti accompagniamo in ogni fase
            per garantire il massimo comfort nella tua abitazione.
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {services.map((service, index) => (
            <div
              key={service.title}
              onMouseEnter={() => setHovered(index)}
              onMouseLeave={() => setHovered(null)}
              className={`rounded-2xl p-7 transition-all duration-300 cursor-default ${
                hovered === index
                  ? 'bg-orange-500 -translate-y-2'
                  : 'bg-[#F8F5F0]'
              }`}
            >
              {/* Icon */}
              <div
                className={`w-14 h-14 flex items-center justify-center rounded-xl mb-5 transition-all ${
                  hovered === index ? 'bg-white' : 'bg-orange-100'
                }`}
              >
                <i
                  className={`${service.icon} text-2xl transition-colors ${
                    hovered === index ? 'text-orange-500' : 'text-orange-500'
                  }`}
                ></i>
              </div>

              {/* Title */}
              <h3
                className={`text-lg font-bold mb-3 leading-snug transition-colors ${
                  hovered === index ? 'text-white' : 'text-gray-900'
                }`}
              >
                {service.title}
              </h3>

              {/* Description */}
              <p
                className={`text-sm leading-relaxed mb-5 transition-colors ${
                  hovered === index ? 'text-white/90' : 'text-gray-500'
                }`}
              >
                {service.description}
              </p>

              {/* Points */}
              <ul className="flex flex-col gap-2">
                {service.points.map((p) => (
                  <li key={p} className="flex items-center gap-2">
                    <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                      <i
                        className={`ri-check-line text-sm font-bold transition-colors ${
                          hovered === index ? 'text-white' : 'text-orange-500'
                        }`}
                      ></i>
                    </div>
                    <span
                      className={`text-xs font-medium transition-colors ${
                        hovered === index ? 'text-white/90' : 'text-gray-600'
                      }`}
                    >
                      {p}
                    </span>
                  </li>
                ))}
              </ul>

              {/* Link */}
              <div className="mt-6">
                <button
                  onClick={() => {
                    const el = document.getElementById('contatti');
                    if (el) el.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className={`flex items-center gap-1 text-sm font-semibold transition-colors cursor-pointer ${
                    hovered === index ? 'text-white' : 'text-orange-500'
                  }`}
                >
                  Richiedi info
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-sm"></i>
                  </div>
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA Banner */}
        <div className="mt-12 bg-gradient-to-r from-orange-500 to-orange-600 rounded-2xl p-8 md:p-10 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h3 className="text-xl md:text-2xl font-bold text-white mb-2">
              Hai bisogno di un intervento urgente?
            </h3>
            <p className="text-white/85 text-sm md:text-base">
              Siamo disponibili 24 ore su 24, 365 giorni l&apos;anno. Chiamaci subito!
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 flex-shrink-0">
            <a
              href="tel:+393806328251"
              className="flex items-center gap-2 bg-white text-orange-600 font-bold text-sm px-6 py-3 rounded-full hover:bg-orange-50 transition-colors cursor-pointer whitespace-nowrap justify-center"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-phone-fill text-sm"></i>
              </div>
              +39 380 632 8251
            </a>
            <a
              href="https://wa.me/393806328251"
              target="_blank"
              rel="nofollow noreferrer"
              className="flex items-center gap-2 bg-white/20 border border-white/50 text-white font-bold text-sm px-6 py-3 rounded-full hover:bg-white/30 transition-colors cursor-pointer whitespace-nowrap justify-center"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-whatsapp-line text-sm"></i>
              </div>
              WhatsApp
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
